import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { DocumentService } from 'src/app/services/core/document/document.service';
@UntilDestroy()

@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.css']
})
export class AddDocumentComponent implements OnInit {
  documentForm!: FormGroup
  docId: any;
  submitted = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private documentService: DocumentService
  ) { }

  ngOnInit(): void {
    this.documentForm = this.fb.group({
      name: ['', Validators.required],
      key: ['', Validators.required],
      type: ['', Validators.required],
    })

    this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((params) => {
      this.docId = params["id"];
      if (this.docId) {
        this.getById();
      }
    });
  }

  getById() {
    this.documentService.getById(this.docId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.documentForm.patchValue({
          ...data
        })
      }
    })
  }

  onSave() {
    this.submitted = true;
    if (this.documentForm.invalid) {
      return;
    }
    let payload = this.documentForm.value;
    this.documentService.save(this.docId, payload).pipe(untilDestroyed(this)).subscribe(
      (data) => {
        if (data) {
          this.router.navigateByUrl("configurations/documents");
        }
      }
    );
  }

  get form(){
    return this.documentForm.value
  }
}
